import { Formik } from "formik";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import { useState, Fragment } from "react";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import validationSchema from "./validationSchema";
import { useAxios, useComponent } from "../../../hooks";
import AddSample from "./add sample components/AddSample";
import { objectFromFormData } from "./templateDetailsObject";
import WhatsappPreview from "../whatsapp interface/WhatsappPreview";
import TemplateHeader from "./template header component/TemplateHeader";
import TemplateBody from "./template body components/TemplateBody";
import TemplateFooter from "./template footer components/TemplateFooter";
import TemplateButtons from "./template button components/TemplateButtons";
import {
  ComponentHeader,
  Paper,
  PageHeader,
  ButtonFooter,
  Chip,
} from "../../../components";
import { CancelButton } from "../../css components/Button";
import TestTemplate from "../whatsapp interface/TestTemplate";
import { colors } from "../../css components/Style";

export default function Form({
  editState,
  setEditState,
  formData,
  templateData,
  agentID,
  language,
  category,
  botDetails,
  pagePermissions,
  agentName,
}) {
  const dispatch = useDispatch();
  const { alert } = useComponent();
  const navigation = useNavigate();

  const [popUp, setPopUp] = useState(false);
  const [addSample, setAddSample] = useState(false);

  const x_sso_token = sessionStorage.getItem("ida_sso_login");
  const { accessToken, authToken } = useSelector(
    (state) => state.memberDetails
  );

  const axios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: x_sso_token !== null ? authToken : "Bearer " + accessToken,
  });

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(formData, { setSubmitting }) => {
        setSubmitting(true);
        var data = objectFromFormData(formData);
        var count_var1 = (formData.templateBody.text.match(/\{{/g) || [])
          .length;

        var count_var2 = (formData.templateBody.text.match(/\}}/g) || [])
          .length;

        if (count_var1 === count_var2) {
          axios({
            url: "/wa/template/create/" + agentID,
            method: "POST",
            data: data,
          })
            .then((response) => {
              if (response.status) {
                setSubmitting(false);
                alert.success(response.message.displayMessage);

                navigation(
                  pages.templateDetails.route +
                    response.data.template_id +
                    "?agentID=" +
                    agentID +
                    "&agentName=" +
                    agentName
                );
              } else {
                dispatch(alert.error(response.message.displayMessage));
              }
            })
            .finally(() => {
              // always reset submitting after request finishes
              setSubmitting(false);
            });
        } else {
          alert.error("Please match the variable!");
        }
      }}
    >
      {(formikProps) => (
        <Fragment>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <PageHeader
                title="Template Details"
                pageName={"Template Details"}
                buttons={[
                  <Chip
                    background={colors.sideBarSubColor}
                    label={`Agent - ${agentName}`}
                  />,
                  <CancelButton
                    variant="outlined"
                    onClick={() =>
                      navigation(
                        pages.templateList.route +
                          "?agentID=" +
                          agentID +
                          "&agentName=" +
                          agentName
                      )
                    }
                  >
                    Back
                  </CancelButton>,
                  formikProps.values.ID && (
                    <ApprovedChip formikProps={formikProps} />
                  ),
                  <PendingChip formikProps={formikProps} />,
                  <RejectedChip formikProps={formikProps} />,
                ]}
              />
            </Grid>

            <Grid item xs={12} sm={9}>
              <FormDisplay
                setAddSample={setAddSample}
                formikProps={formikProps}
                templateData={templateData}
                agentID={agentID}
                language={language}
                category={category}
                addSample={addSample}
                botDetails={botDetails}
                pagePermissions={pagePermissions}
              />

              <TemplateHeader formikProps={formikProps} addSample={addSample} />

              <TemplateBody formikProps={formikProps} addSample={addSample} />

              <TemplateFooter formikProps={formikProps} addSample={addSample} />

              <TemplateButtons
                formikProps={formikProps}
                addSample={addSample}
              />

              {(formikProps.values.templateBody.count_of_variable > 0 ||
                formikProps.values.templateHeader.count_of_variable > 0 ||
                formikProps.values.templateButtons?.buttons?.length > 0) && (
                <AddSample formikProps={formikProps} />
              )}
            </Grid>

            <Grid item xs={12} sm={3}>
              <Paper style={{ position: "sticky", top: "0" }}>
                <Grid item xs={12}>
                  <ComponentHeader
                    title="Template Preview"
                    subtitle={
                      "The template will look like this on users screen."
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <WhatsappPreview formikProps={formikProps.values} />
                </Grid>
              </Paper>
            </Grid>

            {editState && !formikProps.values.ID && (
              <Grid item xs={12}>
                <ButtonFooter
                  ID={formikProps.values.ID}
                  editState={editState}
                  setEditState={setEditState}
                  formikProps={formikProps}
                />
              </Grid>
            )}
          </Grid>
          <TestTemplate
            popUp={popUp}
            setPopUp={setPopUp}
            agentID={agentID}
            templateID={formData.ID}
          />
        </Fragment>
      )}
    </Formik>
  );

  function ApprovedChip({ formikProps }) {
    return (
      formikProps.values.ID &&
      formikProps.values.verifiedStatus ===
        "8360b5eca314424a9d56c37004ccecc9" && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              width: "15px",
              height: "15px",
              borderRadius: "50%",
              background: colors.green,
              margin: "4px",
            }}
          />
          <Typography variant="h6">Approved</Typography>
        </div>
      )
    );
  }

  function PendingChip({ formikProps }) {
    return (
      formikProps.values.ID &&
      formikProps.values.verifiedStatus ===
        "531c1247d1ca4329b4eef4596a099b52" && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              width: "15px",
              height: "15px",
              borderRadius: "50%",
              background: colors.yellow,
              margin: "4px",
            }}
          />
          <Typography variant="h6">Pending</Typography>
        </div>
      )
    );
  }

  function RejectedChip({ formikProps }) {
    return (
      formikProps.values.ID &&
      formikProps.values.verifiedStatus ===
        "c280844cac4643698021059955d6bbe5" && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              width: "15px",
              height: "15px",
              borderRadius: "50%",
              background: colors.error,
              margin: "4px",
            }}
          />
          <Typography variant="h6">Failed</Typography>
        </div>
      )
    );
  }
}
